function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Maintenance",
  transform: "translate(-780.000000, -248.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(704.000000, 248.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "barrier",
  transform: "translate(76.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "0 22.4 74.4827586 89.6 124.137931 89.6 49.6551724 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "49.6551724 22.4 124.137931 89.6 192.413793 89.6 117.931034 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "0 89.6 74.4827586 89.6 0 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "285.517241 22.4 235.862069 22.4 310.344828 89.6 360 89.6"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "117.931034 22.4 192.413793 89.6 242.068966 89.6 167.586207 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "360 22.4 285.517241 22.4 360 89.6"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "167.586207 22.4 242.068966 89.6 310.344828 89.6 235.862069 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "0 123.2 74.4827586 190.4 124.137931 190.4 49.6551724 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "49.6551724 123.2 124.137931 190.4 192.413793 190.4 117.931034 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "0 190.4 74.4827586 190.4 0 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "285.517241 123.2 235.862069 123.2 310.344828 190.4 360 190.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "117.931034 123.2 192.413793 190.4 242.068966 190.4 167.586207 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "360 123.2 285.517241 123.2 360 190.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FDB942",
  points: "167.586207 123.2 242.068966 190.4 310.344828 190.4 235.862069 123.2"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(24.827586, 0.000000)",
  fill: "#143441"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24.8275862 0 24.8275862 22.4 0 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 89.6 24.8275862 89.6 24.8275862 123.2 0 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 190.4 24.8275862 190.4 24.8275862 257.6 0 257.6"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "0 257.6 74.4827586 257.6 74.4827586 280 0 280"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#143441",
  points: "310.344828 0 335.172414 0 335.172414 22.4 310.344828 22.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#143441",
  points: "310.344828 89.6 335.172414 89.6 335.172414 123.2 310.344828 123.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#143441",
  points: "310.344828 190.4 335.172414 190.4 335.172414 257.6 310.344828 257.6"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F485F",
  points: "285.517241 257.6 360 257.6 360 280 285.517241 280"
})))));

var SvgMaintenance = function SvgMaintenance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 280",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maintenance.50327002.svg";
export { ForwardRef as ReactComponent };